import React from 'react';
import './Technical.css';


export default function Fundamental(props) {
    const item = props.fundata;
    const newItem = props?.funXDetails;
    return (
        <>
            <table className="table_content"  >
                <tbody>
                    <tr>
                        <td className=" highlited_row boldfont" colSpan="4" >Ratios</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">Mkt Cap(Billion)</td>
                        <td className="">{item.marketCap ? item.marketCap : ''}</td>
                        <td className="  fontzwt">P/E</td>
                        <td className=" ">{item.pe ? item.pe : ''}</td>
                    </tr>
                    <tr> 
                        <td className=" fontzwt">P/B</td>
                        <td className=" ">{newItem.PERatio ? item.pb : ''}</td>
                        <td className=" fontzwt">Quick Ratio</td>
                        <td className="">{newItem.QuickRatio ? newItem.QuickRatio : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">P/S </td>
                        <td className="">{newItem.PSRatio ? newItem.PSRatio : ''}</td>
                        <td className=" fontzwt">Asset Turnover Ratio </td>
                        <td className="">{newItem.AssetTurnoverRatio ? newItem.AssetTurnoverRatio : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">Net Profit Margin (NPM) </td>
                        <td className="">{newItem.NetProfitMargin ? newItem.NetProfitMargin : ''}</td>
                        <td className=" fontzwt">Return on Equity (ROE)</td>
                        <td className="">{newItem.ReturnonEquity ? newItem.ReturnonEquity : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">EBITDA Margin </td>
                        <td className="">{newItem.EBITDAMargin ? newItem.EBITDAMargin : ''}</td>
                        <td className=" fontzwt">ROCE</td>
                        <td className="">{newItem.ROCE ? newItem.ROCE : ''}</td>
                    </tr>                     
                    <tr>
                        <td className=" fontzwt">Return on Assets (ROA)</td>
                        <td className="">{newItem.ReturnonAssets ? newItem.ReturnonAssets : ''} </td>
                        <td className=" fontzwt">Return on Investment (ROI)</td>
                        <td className="">{newItem.ReturnonInvestment ? newItem.ReturnonInvestment : ''} </td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">Debt to Equity (D/E Ratio)</td>
                        <td className="">{newItem.DebttoEquity ? newItem.DebttoEquity : ''}</td>
                        <td className=" fontzwt">EV / Free Cash Flow</td>
                        <td className="">{newItem.EVFreeCashFlow ? newItem.EVFreeCashFlow : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">1Y Historical EPS Growth</td>
                        <td className="">{newItem['1YHistoricalEPSGrowth'] ? newItem['1YHistoricalEPSGrowth'] : ''}</td>
                        <td className=" fontzwt">1Y Historical Revenue</td>
                        <td className="">{newItem['1YHistoricalRevenueGrowth'] ? newItem['1YHistoricalRevenueGrowth'] : ''}</td>
                    </tr>
                    <tr>
                        <td className="highlited_row boldfont" colSpan="4" >Growth Rate</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">1Y Historical EBITDA Growth</td>
                        <td className="">{newItem['1YHistoricalEBITDAGrowth'] ? newItem['1YHistoricalEBITDAGrowth'] : ''}</td>
                        <td className=" fontzwt">5Y Historical EPS Growth</td>
                        <td className="">{newItem['5YHistoricalEPSGrowth'] ? newItem['5YHistoricalEPSGrowth'] : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">5Y Historical EBITDA Growth</td>
                        <td className="">{newItem['5YHistoricalEBITDAGrowth'] ? newItem['5YHistoricalEBITDAGrowth'] : ''}</td>
                        <td className=" fontzwt">5Y Historical Revenue Growth</td>
                        <td className="">{newItem['5YHistoricalRevenueGrowth'] ? newItem['5YHistoricalRevenueGrowth'] : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">5Y Avg Return on Equity</td>
                        <td>{newItem['5YAvgReturnonEquity'] ? newItem['5YAvgReturnonEquity'] : ''}</td>
                        <td className=" fontzwt">5Y Avg Net Profit Margin</td>
                        <td>{newItem['5YAvgNetProfitMargin'] ? newItem['5YAvgNetProfitMargin'] : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">5Y Avg EBITDA Margin</td>
                        <td>{newItem['5YAvgEBITDAMargin'] ? newItem['5YAvgEBITDAMargin'] : ''}</td>
                        <td className=" fontzwt">1Y Forward EBITDA Growth</td>
                        <td>{newItem['1YForwardEBITDAGrowth'] ? newItem['1YForwardEBITDAGrowth'] : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">1Y Forward EPS Growth</td>
                        <td>{newItem['1YForwardEPSGrowth'] ? newItem['1YForwardEPSGrowth'] : ''}</td>
                        <td className=" fontzwt">1Y Forward Revenue Growth</td>
                        <td>{newItem['1YForwardRevenueGrowth'] ? newItem['1YForwardRevenueGrowth'] : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">Forward PE Ratio</td>
                        <td>{newItem['ForwardPERatio'] ? newItem['ForwardPERatio'] : ''}</td>
                        <td className=" fontzwt">Forward PS Ratio</td>
                        <td>{newItem['ForwardPSRatio'] ? newItem['ForwardPSRatio'] : ''}</td>
                    </tr>
                    <tr>
                        <td className=" fontzwt">Beta</td>
                        <td>{newItem['Beta'] ? newItem['Beta'] : ''}</td>
                        <td className=" fontzwt"></td>
                        <td> </td>
                    </tr>                    
                </tbody>
            </table>


        </>
    )
}
